import { render, staticRenderFns } from "./action-rounded.vue?vue&type=template&id=3cc728a5&scoped=true&"
import script from "./action-rounded.vue?vue&type=script&lang=js&"
export * from "./action-rounded.vue?vue&type=script&lang=js&"
import style0 from "./action-rounded.vue?vue&type=style&index=0&id=3cc728a5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cc728a5",
  null
  
)

export default component.exports